import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"

const useStyles = makeStyles(() => ({
  body: {
    display: "flex",
    flexDirection: "row",
    color: colors.greyStrong,
    justifyContent: "space-between",
  },

  title: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
      fontSize: "24px",
      color: colors.primary,
      textAlign: "left",
    },
  },

  search: {
    "&.MuiFormControl-root": {
      "& .MuiOutlinedInput-root": {
        "& .MuiOutlinedInput-input": {
          textAlign: "right",
        },
      },
    },
  },

  subTitle: {
    margin: "25px 0",
  },

  listContainer: {
    width: "50%",
  },

  listBody: {
    margin: "80px 70px 0 110px",
  },

  inputButton: {
    "&.MuiButton-root": {
      width: "205px",
      marginTop: "20px",
    },
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
  },

  searchBar: {
    display: "flex",
    justifyContent: "flex-end",
  },
}))

export default useStyles
